import { Button, DatePicker, Form, Input } from "antd";
import moment from "moment";
import Flex from "../../../components/Flex";
import { ListOrdersPayloadDto } from "../../../store/actions/dtos/ListOrdersPayloadDto";

const { RangePicker } = DatePicker;

type OrderSearchFormProps = {
  onSearch: (values: Partial<ListOrdersPayloadDto>) => void;
};

export function OrderSearchForm({ onSearch }: OrderSearchFormProps) {
  const [form] = Form.useForm();

  const handleFinish = (values: Record<string, any>) => {
    onSearch({
      SearchBySoNo: values.soNo ?? "",
      SearchByPoNo: values.poNo ?? "",
      SearchByMeycoNo: values.meycoNo ?? "",
      SearchByJobTitle: values.jobTitle ?? "",
      OrderStartDate: values.orderDate?.[0]
        ? moment(values.orderDate[0]).format("YYYY-MM-DD")
        : "",
      OrderEndDate: values.orderDate?.[1]
        ? moment(values.orderDate[1]).format("YYYY-MM-DD")
        : "",
      ShipStartDate: values.shipDate?.[0]
        ? moment(values.shipDate[0]).format("YYYY-MM-DD")
        : "",
      ShipEndDate: values.shipDate?.[1]
        ? moment(values.shipDate[1]).format("YYYY-MM-DD")
        : "",
    });
  };

  return (
    <Form
      form={form}
      onFinish={handleFinish}
      layout="vertical"
      style={{ width: "100%", marginBottom: 20 }}
      className="filter__select__wrap"
    >
      <Flex wrap="wrap" align="center" style={{ width: "100%" }} gap={20}>
        <Form.Item label="Search SoNo" name="soNo" style={{ marginBottom: 0 }}>
          <Input allowClear placeholder="So#" style={{ width: 180 }} />
        </Form.Item>
        <Form.Item label="Search PoNo" name="poNo" style={{ marginBottom: 0 }}>
          <Input allowClear placeholder="Po#" style={{ width: 180 }} />
        </Form.Item>
        <Form.Item
          label="Search MeycoNo"
          name="meycoNo"
          style={{ marginBottom: 0 }}
        >
          <Input allowClear placeholder="Meyco#" style={{ width: 180 }} />
        </Form.Item>
        <Form.Item
          label="Search Job Name"
          name="jobTitle"
          style={{ marginBottom: 0 }}
        >
          <Input allowClear placeholder="Job Name" style={{ width: 180 }} />
        </Form.Item>
        <Form.Item
          label="Order Date"
          name="orderDate"
          style={{ marginBottom: 0 }}
        >
          <RangePicker />
        </Form.Item>
        <Form.Item
          label="Shipping Date"
          name="shipDate"
          style={{ marginBottom: 0 }}
        >
          <RangePicker />
        </Form.Item>
        <Form.Item label=" " style={{ marginBottom: 0 }} >
          <Button type="primary" htmlType="submit">
            Search
          </Button>
        </Form.Item>
      </Flex>
    </Form>
  );
}
